<main>
    <div *ngIf="chargingStation?.location; else notFound" leaflet id="map" [leafletOptions]="mapOptions"
        (leafletMapReady)="onMapReady($event)">
    </div>

    <div class="wrapper" *ngIf="chargingStation; else notFound">
        <div class="container">
            <h2 i18n="@@NoSubscriptionForCharingPointErrorText">Etwas ist schiefgelaufen</h2>
            <br>
            <a class="button hero" id="go_back" (click)="goBack()" i18n="@@GoBackButton">
                Zurück
            </a>
        </div>
    </div>
</main>

<ng-template #notFound>
    <div class="container">
        <h1 i18n="@@404ErrorText"><span>Fehler 404</span></h1>
        <h2 i18n="@@NoChargingPointErrorText">Der Ladepunkt konnte nicht gefunden werden</h2>
    </div>
</ng-template>
